<svelte:options customElement="dst-abo-sidebar" />

<script lang="ts">
	import { baseUrls, utmParams } from '@/config.ts';
	import { register as registerClosables } from '@/lib/closable.ts';
	import { addUrlParams } from '@/lib/utils.ts';
	import { closableInformElement } from '@/stores/header_store.ts';
	import { dstPur, dstSupporterThick } from '@derstandard/styling-toolkit/src/svg/lib.js';
	import {
		mdiApps,
		mdiBookOpenPageVariantOutline,
		mdiChevronRight,
		mdiClose,
		mdiDotsHorizontal,
		mdiFaceAgent,
		mdiFrequentlyAskedQuestions,
		mdiGiftOutline,
		mdiNewspaper,
		mdiSchoolOutline,
		mdiShoppingOutline,
		mdiStarPlusOutline,
		mdiTabletCellphone,
		mdiViewColumn,
	} from '@mdi/js';
	import { onMount } from 'svelte';

	let root;
	const baseUrl = baseUrls.abo_default ?? '';
	const supporterUrl = addUrlParams(baseUrls.checkout_supporter, utmParams);

	onMount(async () => {
		registerClosables(root, $closableInformElement);
	});
</script>

<div class="app--header--sidebar" id="app-sidebar" bind:this={root}>
	<div class="app--header--sidebar--content u-scrollbar">
		<div class="app--header--sidebar--header">
			<div class="app-header--sidebar--heading">Abo & Angebote</div>
			<button type="button" title="Menü ausblenden" data-closable-target="app-sidebar">
				<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path fill="currentColor" d={mdiClose} />
				</svg>
			</button>
		</div>
		<nav aria-label="Haupt-Navigation">
			<ul>
				<li><slot name="search" /></li>
				<li>
					<a href="{baseUrl}/">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiApps} />
						</svg>
						Startseite
					</a>
				</li>
				<li>
					<a href="{baseUrl}/produkte/ueberblick/">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiViewColumn} />
						</svg>
						Überblick
					</a>
				</li>
				<li>
					<a href={supporterUrl}>
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={dstSupporterThick} />
						</svg>
						Unterstützung abschließen
					</a>
				</li>
				<li>
					<a href="{baseUrl}/produkte/studierenden-angebote/">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiSchoolOutline} />
						</svg>
						Abos für Studierende
					</a>
				</li>
				<li>
					<a href="{baseUrl}/produkte/upgrade/">
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
							<path fill="currentColor" d={mdiStarPlusOutline} />
						</svg>
						Upgrade für Abonnent:innen
					</a>
				</li>
				<li>
					<details open>
						<summary>
							<div>
								<span>Digital</span>
								<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path fill="currentColor" d={mdiChevronRight} />
								</svg>
							</div>
						</summary>
						<ul>
							<li>
								<a href="{baseUrl}/produkte/digital/#pur">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={dstPur} />
									</svg>
									derStandard.at Pur
								</a>
							</li>
							<li>
								<a href="{baseUrl}/produkte/digital/#smart">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiTabletCellphone} />
									</svg>
									DER STANDARD Smart
								</a>
							</li>
							<li>
								<a href="{baseUrl}/produkte/digital/#epaper">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiTabletCellphone} />
									</svg>
									DER STANDARD ePaper
								</a>
							</li>
							<li>
								<a href="{baseUrl}/produkte/digital/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiDotsHorizontal} />
									</svg>
									alle Digital-Angebote
								</a>
							</li>
						</ul>
					</details>
					<details open>
						<summary>
							<div>
								<span>Print</span>
								<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path fill="currentColor" d={mdiChevronRight} />
								</svg>
							</div>
						</summary>
						<ul>
							<li>
								<a href="{baseUrl}/produkte/print/#klassik">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiNewspaper} />
									</svg>
									DER STANDARD Klassik
								</a>
							</li>
							<li>
								<a href="{baseUrl}/produkte/print/#kompakt">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiNewspaper} />
									</svg>
									DER STANDARD Kompakt
								</a>
							</li>
							<li>
								<a href="{baseUrl}/produkte/print/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiDotsHorizontal} />
									</svg>
									alle Print-Angebote
								</a>
							</li>
						</ul>
					</details>
					<details open>
						<summary>
							<div>
								<span>Shop</span>
								<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path fill="currentColor" d={mdiChevronRight} />
								</svg>
							</div>
						</summary>
						<ul>
							<li>
								<a href="{baseUrl}/shop/magazine/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiBookOpenPageVariantOutline} />
									</svg>
									Magazine
								</a>
							</li>
							<li>
								<a href="{baseUrl}/shop/merchandise/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiShoppingOutline} />
									</svg>
									Merchandise
								</a>
							</li>
							<li>
								<a href="{baseUrl}/shop/der-oesterreichische-film/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiShoppingOutline} />
									</svg>
									Der österreichische Film
								</a>
							</li>
							<li>
								<a href="{baseUrl}/shop/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiDotsHorizontal} />
									</svg>
									alle Angebote im Shop
								</a>
							</li>
						</ul>
					</details>
					<details open>
						<summary>
							<div>
								<span>Service</span>
								<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
									<path fill="currentColor" d={mdiChevronRight} />
								</svg>
							</div>
						</summary>
						<ul>
							<li>
								<a href="{baseUrl}/abovorteile/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiGiftOutline} />
									</svg>
									Abovorteile
								</a>
							</li>
							<li>
								<a href="{baseUrl}/aboservice/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiFaceAgent} />
									</svg>
									Aboservice
								</a>
							</li>
							<li>
								<a href="{baseUrl}/fragen-antworten/">
									<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
										<path fill="currentColor" d={mdiFrequentlyAskedQuestions} />
									</svg>
									Fragen & Antworten
								</a>
							</li>
						</ul>
					</details>
				</li>
			</ul>
		</nav>
	</div>
	<div class="app--header--sidebar--backdrop" data-closable-target="app-sidebar" />
</div>

<style lang="scss" global>
	@use '../../scss/DstSidebar.scss';
</style>
